import { defaultCurrency } from '..'

const currencySymbols: Record<string, string> = {
  EUR: '€',
  ESD: '$',
  RUB: '₽',
  UAH: '₴',
  TND: 'DT',
  TJS: 'SM',
  KGS: 'с',
  UZS: "So'm",
  AUD: '$',
  USD: '$',
  CNY: '¥',
  TWD: 'NT$',
  GBP: '£',
  KRW: '₩',
  TRY: '₺',
}

export const getCurrencySymbol = (currency: string | undefined) => currencySymbols[currency || defaultCurrency] || ''
